module.exports = __webpack_public_path__ + "img/carbs-img-1.c62db335.png";